// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/notification.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/notification.proto.
 */
export const file_console_admin_v1_notification: GenFile = /*@__PURE__*/
  fileDesc("CiNjb25zb2xlL2FkbWluL3YxL25vdGlmaWNhdGlvbi5wcm90bxIQY29uc29sZS5hZG1pbi52MSKnAgoMTm90aWZpY2F0aW9uEgoKAmlkGAEgASgJEg4KBm9yZ19pZBgCIAEoCRIMCgRraW5kGAMgASgJEhAKCHNldmVyaXR5GAQgASgJEg0KBXRpdGxlGAUgASgJEgwKBGJvZHkYBiABKAkSDQoFY291bnQYByABKA0SLAoIZmlyc3RfYXQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEisKB2xhc3RfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEisKB3JlYWRfYXQYCiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEicKBmRldGFpbBgLIAEoCzIXLmdvb2dsZS5wcm90b2J1Zi5TdHJ1Y3QidgoYTGlzdE5vdGlmaWNhdGlvbnNSZXF1ZXN0Eg4KBm9yZ19pZBgBIAEoCRITCgt1bnJlYWRfb25seRgCIAEoCBIRCglwYWdlX3NpemUYAyABKA0SEgoKcGFnZV90b2tlbhgEIAEoCRIOCgZvZmZzZXQYBSABKA0iigEKGUxpc3ROb3RpZmljYXRpb25zUmVzcG9uc2USNQoNbm90aWZpY2F0aW9ucxgBIAMoCzIeLmNvbnNvbGUuYWRtaW4udjEuTm90aWZpY2F0aW9uEhcKD25leHRfcGFnZV90b2tlbhgCIAEoCRIOCgZ1bnJlYWQYAyABKA0SDQoFdG90YWwYBCABKA0iOwocTWFya05vdGlmaWNhdGlvbnNSZWFkUmVxdWVzdBILCgNpZHMYASADKAkSDgoGb3JnX2lkGAIgASgJIi8KHU1hcmtOb3RpZmljYXRpb25zUmVhZFJlc3BvbnNlEg4KBm1hcmtlZBgBIAEoDTL9AQoTTm90aWZpY2F0aW9uU2VydmljZRJsChFMaXN0Tm90aWZpY2F0aW9ucxIqLmNvbnNvbGUuYWRtaW4udjEuTGlzdE5vdGlmaWNhdGlvbnNSZXF1ZXN0GisuY29uc29sZS5hZG1pbi52MS5MaXN0Tm90aWZpY2F0aW9uc1Jlc3BvbnNlEngKFU1hcmtOb3RpZmljYXRpb25zUmVhZBIuLmNvbnNvbGUuYWRtaW4udjEuTWFya05vdGlmaWNhdGlvbnNSZWFkUmVxdWVzdBovLmNvbnNvbGUuYWRtaW4udjEuTWFya05vdGlmaWNhdGlvbnNSZWFkUmVzcG9uc2ViBnByb3RvMw", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message console.admin.v1.Notification
 */
export type Notification = Message<"console.admin.v1.Notification"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string org_id = 2;
   */
  orgId: string;

  /**
   * Stable kinds: `device.limit_refused`, `device.org_mismatch`,
   * `seat.limit_refused`, `device.outbox_gap`.
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * `info`, `warning`, `critical`.
   *
   * @generated from field: string severity = 4;
   */
  severity: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: string body = 6;
   */
  body: string;

  /**
   * How many times this folded entry recurred.
   *
   * @generated from field: uint32 count = 7;
   */
  count: number;

  /**
   * @generated from field: google.protobuf.Timestamp first_at = 8;
   */
  firstAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp last_at = 9;
   */
  lastAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp read_at = 10;
   */
  readAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Struct detail = 11;
   */
  detail?: JsonObject | undefined;
};

/**
 * Describes the message console.admin.v1.Notification.
 * Use `create(NotificationSchema)` to create a new message.
 */
export const NotificationSchema: GenMessage<Notification> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_notification, 0);

/**
 * @generated from message console.admin.v1.ListNotificationsRequest
 */
export type ListNotificationsRequest = Message<"console.admin.v1.ListNotificationsRequest"> & {
  /**
   * Org admins: their own (may be empty). Staff: an org id, or empty for
   * everything staff can see.
   *
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: bool unread_only = 2;
   */
  unreadOnly: boolean;

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;

  /**
   * Rows to skip, newest first, for a numbered page. Used in place of
   * `page_token`.
   *
   * @generated from field: uint32 offset = 5;
   */
  offset: number;
};

/**
 * Describes the message console.admin.v1.ListNotificationsRequest.
 * Use `create(ListNotificationsRequestSchema)` to create a new message.
 */
export const ListNotificationsRequestSchema: GenMessage<ListNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_notification, 1);

/**
 * @generated from message console.admin.v1.ListNotificationsResponse
 */
export type ListNotificationsResponse = Message<"console.admin.v1.ListNotificationsResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.Notification notifications = 1;
   */
  notifications: Notification[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: uint32 unread = 3;
   */
  unread: number;

  /**
   * How many notifications match, across every page.
   *
   * @generated from field: uint32 total = 4;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.ListNotificationsResponse.
 * Use `create(ListNotificationsResponseSchema)` to create a new message.
 */
export const ListNotificationsResponseSchema: GenMessage<ListNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_notification, 2);

/**
 * @generated from message console.admin.v1.MarkNotificationsReadRequest
 */
export type MarkNotificationsReadRequest = Message<"console.admin.v1.MarkNotificationsReadRequest"> & {
  /**
   * Empty marks every notification the caller can see as read.
   *
   * @generated from field: repeated string ids = 1;
   */
  ids: string[];

  /**
   * Only this organization's notifications. Org admins: their own (may be
   * empty). Staff: an org id, or empty for everything staff can see.
   *
   * @generated from field: string org_id = 2;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.MarkNotificationsReadRequest.
 * Use `create(MarkNotificationsReadRequestSchema)` to create a new message.
 */
export const MarkNotificationsReadRequestSchema: GenMessage<MarkNotificationsReadRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_notification, 3);

/**
 * @generated from message console.admin.v1.MarkNotificationsReadResponse
 */
export type MarkNotificationsReadResponse = Message<"console.admin.v1.MarkNotificationsReadResponse"> & {
  /**
   * @generated from field: uint32 marked = 1;
   */
  marked: number;
};

/**
 * Describes the message console.admin.v1.MarkNotificationsReadResponse.
 * Use `create(MarkNotificationsReadResponseSchema)` to create a new message.
 */
export const MarkNotificationsReadResponseSchema: GenMessage<MarkNotificationsReadResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_notification, 4);

/**
 * Internal notifications for administrators and staff: things the console
 * noticed that a person should act on, such as a sign-in refused by the
 * device limit or an operator trying a tablet that belongs to another
 * organization. Org admins see their organization's; staff see all plus
 * staff-only ones. Repeats within a day fold into one entry with a count.
 *
 * @generated from service console.admin.v1.NotificationService
 */
export const NotificationService: GenService<{
  /**
   * @generated from rpc console.admin.v1.NotificationService.ListNotifications
   */
  listNotifications: {
    methodKind: "unary";
    input: typeof ListNotificationsRequestSchema;
    output: typeof ListNotificationsResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.NotificationService.MarkNotificationsRead
   */
  markNotificationsRead: {
    methodKind: "unary";
    input: typeof MarkNotificationsReadRequestSchema;
    output: typeof MarkNotificationsReadResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_notification, 0);

